import { Component, OnInit } from '@angular/core';
import { PaymentPaymentOptionCardFormAbstractForm } from '../payment.payment.option.card.form.abstract-form';

@Component({
    'selector': 'payment-payment-option-card-form-cielo',
    'templateUrl': './payment.payment.option.card.form.cielo.component.html',
    'providers': [],
    'styleUrls': ['../../../../../../payment.component.scss']
})
export class PaymentPaymentOptionCardFormCieloComponent extends
    PaymentPaymentOptionCardFormAbstractForm implements OnInit {
    public ngOnInit(): void {
        this.cieloCyberSource(); // Chamada do fingerprint assim que o componente carregar
    }

    public cieloCyberSource(): void {
        console.log('Cielo CyberSource Fingerprint');
        if (this.paymentMethod.antifraud_option === undefined ||
            this.paymentMethod.antifraud_option === null ||
            this.paymentMethod.antifraud_option === '') {
            return;
        }
        const uuid = this.generateUUID();
        const sessionId = this.paymentMethod.antifraud_option + uuid;
        const orgId = (this.paymentMethod.sandbox_3ds) ? '1snn5n9w' : 'k8vif92e';
        const scriptId = 'braspag-script-data'; // id único com base no orgId
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=${sessionId}`;
            script.id = scriptId;
            document.head.appendChild(script);
        }

        const iframe = document.createElement('iframe');
        iframe.style.width = '100px';
        iframe.style.height = '100px';
        iframe.style.border = '0';
        iframe.style.position = 'absolute';
        iframe.style.top = '-5000px';
        iframe.src = `https://h.online-metrix.net/fp/tags?org_id=${orgId}&session_id=${sessionId}`;
        iframe.id = 'braspag-iframe-data'; // id único com base no orgId
        document.body.appendChild(iframe);
        this.setValue('fingerprint', '.', uuid);
        this.setValue('bpmpi_ordernumber', '.', uuid);
    }

    public generateUUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public setValue( name, selector, value) {
        let element = document.querySelector(selector + name) as HTMLInputElement;
        if (!element) {
            element = document.createElement('input');
            element.type = 'hidden';
            element.className = name;
            document.body.appendChild(element);
        }
        element.value = value;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/payment/payment/option/card/option/form/cielo/payment.payment.option.card.form.cielo.component.ts